import Http from 'axios'
import {
    BASE_URL,
    API_URL,
    VERSION
} from '../config/config'
import store from '../store/index'

export default {
    user: null,
    destroySession() {
        this.user = null
    },
    async currentUser() {
        if (this.user) {
            return this.user
        }
        try {
            let user = await Http.get(API_URL + VERSION + '/user');
            this.user = user;
            store.commit('AuthUser/setUser', user.data.data);
            return user
        } catch (error) {
            if (error.response.status === 401){
                window.localStorage.clear();
                window.location.href='/system/login'
            }
            return error
        }
    },
    async attemptReset(credentials) {
        try {
            let response = await Http.post(API_URL + VERSION + '/password/reset', credentials,);
            return new Promise(resolve => resolve(response))
        } catch (error) {
            return new Promise(reject => reject(error))
        }
    },
    async attemptLogin(credentials) {
        try {
            let response = await Http.post(BASE_URL + '/oauth/token', credentials);
            return new Promise(resolve => resolve(response))
        } catch (error) {
            return new Promise(reject => reject(error))
        }
    },

    addAuthorizationHeader(header) {
        Http.defaults.headers.common['Authorization'] = header
    }
}
